import { createContext } from 'react';
import { initialState, UseSolarMapVisualisationState } from './store';
import { AnyAction } from '@reduxjs/toolkit';

export const SolarMapVisualisationContext = createContext<UseSolarMapVisualisationState>(initialState);
export const SolarMapVisualisationDispatchContext = createContext<React.Dispatch<AnyAction>>(() => null);
